export default {"src":"/_next/static/media/map-pin-range-black.8bc98102.svg","height":14,"width":14};